// tslint:disable
// this is an auto generated file. This will be overwritten

export const setFavourites = `mutation SetFavourites($favourites: [FavouriteInput]) {
  setFavourites(favourites: $favourites) {
    programId
    type
    excludedEvents
    events
  }
}
`;
export const removeFavourite = `mutation RemoveFavourite($id: String) {
  removeFavourite(id: $id) {
    programId
    type
    excludedEvents
    events
  }
}
`;
export const addFavourite = `mutation AddFavourite($favourite: FavouriteInput) {
  addFavourite(favourite: $favourite) {
    programId
    type
    excludedEvents
    events
  }
}
`;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/graphql/mutations.ts